<template>
  <div
    v-show="open"
    class="login-register-area"
  >
    <div
      v-if="loading || googleInfo.hasHash !== false"
      class="loading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <template v-else>
      <header v-show="googleInfo.hasHash === false">
        <i
          v-show="step.history.length > 1"
          class="back icon-chevron-left"
          @click="back"
        />
        <i
          v-show="propStep || hasContinue"
          class="close icon-close"
          @click="close"
        />
        <span class="login-register-area__title">
          {{ step.now === 'inputPhone' ? '會員登入或註冊' : '' }}
          {{ step.now === 'isLogin' ? '會員登入' : '' }}
          {{ step.now === 'isRegister' ? '會員註冊' : '' }}
          {{ step.now === 'setPassword' ? '會員註冊' : '' }}
          {{ step.now === 'forget' ? '驗證手機號碼' : '' }}
          {{ step.now === 'isGuestMemberLogin' ? '驗證手機號碼' : '' }}
          {{ step.now === 'reSetPassword' ? '重設密碼' : '' }}
          {{ step.now === 'phoneValidation' ? '驗證手機號碼' : '' }}
          {{ step.now === 'guestValidation' ? '驗證手機號碼' : '' }}
          {{ step.now === 'mailValidation' ? '驗證E-mail' : '' }}
          {{ step.now === 'changePassword' ? '變更密碼' : '' }}
          {{ step.now === 'guestMemberSetPassword' ? '設定密碼' : '' }}
        </span>
        <p>
          {{ step.now === 'inputPhone' ? '' : '' }}
          {{ step.now === 'isLogin' ? '' : '' }}
          {{ step.now === 'isRegister' ? '此手機號碼尚未註冊，加入會員享受更多服務' : '' }}
          {{ step.now === 'setPassword' ? '設定您的會員密碼來完成註冊' : '' }}
          {{ step.now === 'forget' ? '提醒您：24小時內只能發送3組驗證碼' : '' }}
          {{ step.now === 'isGuestMemberLogin' ? '提醒您：24小時內只能發送3組驗證碼' : '' }}
          {{ step.now === 'reSetPassword' ? '' : '' }}
          {{ step.now === 'phoneValidation' ? '' : '' }}
          {{ step.now === 'guestValidation' ? '' : '' }}
          {{ step.now === 'mailValidation' ? '' : '' }}
          {{ step.now === 'changePassword' ? '' : '' }}
          {{ hasContinue ? '登入或註冊會員來繼續' : '' }}
        </p>
      </header>
      <section
        v-show="googleInfo.hasHash === false"
        class="content"
      >
        <p
          v-if="step.now === 'inputPhone'"
          class="register-notice"
        >
          現在註冊會員即可享有購物金折抵、紅利點數累積並追蹤訂單狀態，還有不定期會員專屬優惠等著您！
        </p>
        <v-form ref="form">
          <div
            v-if="['mailValidation', 'changePassword', 'reSetPassword', 'guestMemberSetPassword'].indexOf(step.now) === -1"
            class="item flex-item"
          >
            <span class="label">
              手機號碼
            </span>
            <v-text-field
              ref="phone"
              class="input"
              label="請輸入手機號碼"
              single-line
              outlined
              :autofocus="!phone || phoneValidate"
              :value="inputData.phone"
              type="tel"
              hide-details="auto"
              maxlength="10"
              :rules="inputData.phoneRule"
              :disabled="['inputPhone'].indexOf(step.now) === -1 && !phoneValidate"
              @input="inputData.phone = full2half($event)"
              @keypress.enter.prevent="clickContinue"
            />
            <v-btn
              v-if="phoneValidate"
              class="btn append-outer"
              depressed
              color="primary"
              :disabled="!phone || inputData.phone.length === 0"
              :outlined="phone && inputData.phone.length > 0"
              @click="clickClear('phone')"
            >
              清除
            </v-btn>
          </div>
          <div
            v-if="step.now === 'mailValidation'"
            class="item flex-item"
          >
            <span class="label">
              E-mail
            </span>
            <v-text-field
              ref="mail"
              v-model="inputData.mail"
              class="input"
              label="請輸入E-mail"
              single-line
              outlined
              :autofocus="!mail || step.now === 'mailValidation'"
              type="mail"
              hide-details="auto"
              :disabled="!continueBtnIsDisabled"
              maxlength="40"
              :rules="inputData.mailRule"
              @keypress.enter.prevent="clickContinue"
            />
            <v-btn
              class="btn append-outer"
              depressed
              color="primary"
              :disabled="inputData.mail.length === 0"
              :outlined="inputData.mail.length > 0"
              @click="clickClear('mail')"
            >
              清除
            </v-btn>
          </div>
          <div
            v-if="step.now === 'isLogin'"
            class="item"
          >
            <span class="label">
              密碼
            </span>
            <v-text-field
              ref="password"
              v-model="inputData.password"
              class="input"
              label="請輸入您的密碼"
              single-line
              outlined
              autofocus
              hide-details="auto"
              maxlength="12"
              :rules="inputData.passwordRule"
              :append-icon="inputData.passwordShow ? icons.mdiEye : icons.mdiEyeOff"
              :type="inputData.passwordShow ? 'text' : 'password'"
              @keypress.enter.prevent="clickContinue"
              @click:append="inputData.passwordShow = !inputData.passwordShow"
            />
            <span
              class="forget"
              @click="clickForget"
            >忘記密碼 ?</span>
          </div>
          <div
            v-if="step.now === 'changePassword'"
            class="item"
          >
            <span class="label">
              舊密碼
            </span>
            <v-text-field
              ref="oldPassword"
              v-model="inputData.oldPassword"
              class="input"
              label="請輸入舊密碼"
              single-line
              outlined
              autofocus
              hide-details="auto"
              maxlength="12"
              :rules="inputData.oldPasswordRule"
              :append-icon="inputData.oldPasswordShow ? icons.mdiEye : icons.mdiEyeOff"
              :type="inputData.oldPasswordShow ? 'text' : 'password'"
              @keypress.enter.prevent="clickContinue"
              @click:append="inputData.oldPasswordShow = !inputData.oldPasswordShow"
            />
          </div>
          <div
            v-if="['isRegister', 'forget', 'phoneValidation', 'guestValidation', 'mailValidation', 'isGuestMemberLogin'].indexOf(step.now) > -1"
            class="item verifiction"
          >
            <span class="label">
              驗證碼
            </span>
            <v-text-field
              ref="verifiction"
              v-model="inputData.verifiction"
              class="input"
              :label="step.now === 'mailValidation' ? '請輸入E-mail驗證碼' : '請輸入手機簡訊驗證碼'"
              single-line
              outlined
              :autofocus="['phoneValidation', 'guestValidation', 'mailValidation'].indexOf(step.now) === -1"
              type="text"
              hide-details="auto"
              maxlength="6"
              :rules="inputData.verifictionRule"
              :readonly="step.now === 'isLogin'"
              @keypress.enter.prevent="clickContinue"
            />
            <v-btn
              class="btn"
              :class="{'is-sending': verifiction.isCountDownIng}"
              outlined
              color="primary"
              :loading="verifiction.isSending"
              :disabled="verifiction.isCountDownIng"
              @click="clickSendVerifiction"
            >
              {{
                verifiction.isCountDownIng ?
                  verifiction.countDown + '秒後重新發送驗證碼' :
                  '發送驗證碼'
              }}
            </v-btn>
          </div>
          <div
            v-if="['setPassword', 'reSetPassword', 'changePassword', 'guestMemberSetPassword'].indexOf(step.now) > -1"
            class="item set-password"
          >
            <span
              v-if="step.now === 'changePassword'"
              class="label"
            >
              新密碼
            </span>
            <span
              v-else
              class="label"
            >
              密碼
            </span>
            <form
              ref="setPassword"
              :lazy-validation="true"
            >
              <v-text-field
                ref="setPasswordInput"
                v-model="inputData.setPassword"
                class="input"
                label="請設定含英數8至12位數的密碼"
                single-line
                outlined
                :autofocus="step.now !== 'changePassword'"
                hide-details="auto"
                maxlength="12"
                :rules="inputData.setPasswordRule"
                :append-icon="inputData.setPasswordShow ? icons.mdiEye : icons.mdiEyeOff"
                :type="inputData.setPasswordShow ? 'text' : 'password'"
                @keypress.enter.prevent="clickContinue"
                @click:append="inputData.setPasswordShow = !inputData.setPasswordShow"
              />
            </form>
            <br>
            <span class="label">
              確認密碼
            </span>
            <form
              ref="setPasswordAgain"
              :lazy-validation="true"
            >
              <v-text-field
                v-model="inputData.setPasswordAgain"
                class="input"
                label="請再輸入一次密碼"
                single-line
                outlined
                hide-details="auto"
                maxlength="12"
                :rules="inputData.setPasswordAgainRule"
                :append-icon="inputData.setPasswordAgainShow ? icons.mdiEye : icons.mdiEyeOff"
                :type="inputData.setPasswordAgainShow ? 'text' : 'password'"
                @keypress.enter.prevent="clickContinue"
                @click:append="inputData.setPasswordAgainShow = !inputData.setPasswordAgainShow"
              />
            </form>
          </div>
        </v-form>
      </section>
      <footer v-show="googleInfo.hasHash === false">
        <v-btn
          class="btn"
          :loading="continueBtnIsLoading"
          :disabled="continueBtnIsDisabled"
          depressed
          color="primary"
          @click="clickContinue"
        >
          {{ step.now === 'inputPhone' ? '下一步' : '' }}
          {{ step.now === 'isLogin' ? '登入' : '' }}
          {{ step.now === 'isRegister' ? '驗證' : '' }}
          {{ step.now === 'setPassword' ? '確定' : '' }}
          {{ step.now === 'forget' ? '驗證' : '' }}
          {{ step.now === 'isGuestMemberLogin' ? '驗證' : '' }}
          {{ step.now === 'reSetPassword' ? '確定' : '' }}
          {{ phoneValidate ? '驗證' : '' }}
          {{ step.now === 'mailValidation' ? '驗證' : '' }}
          {{ step.now === 'changePassword' ? '確定' : '' }}
          {{ step.now === 'guestMemberSetPassword' ? '確定' : '' }}
        </v-btn>
        <!-- <template v-if="['isLogin', 'setPassword', 'forget', 'reSetPassword'].indexOf(step.now) === -1"> -->
        <div
          v-if="['inputPhone', 'isRegister'].indexOf(step.now) > -1"
          class="social-btn"
        >
          <template>
            <p>或</p>
            <v-btn
              class="social-login google-login"
              color="primary"
              outlined
              :loading="googleInfo.isLoading"
              @click="GoogleLoginIn"
            >
              <img
                src="~/assets/image/google.svg"
                alt="google-icon"
              >
              使用Google帳號
            </v-btn>
            <v-btn
              class="social-login apple-login"
              color=""
              outlined
              :loading="googleInfo.isLoading"
              @click="AppleLoginIn"
            >
              <img
                src="~/assets/image/social-apple.png"
                alt="apple-icon"
              >
              使用Apple帳號
            </v-btn>
            <span v-show="googleInfo.canLogin === false">
              請確認允許開啟第三方 Cookie<br>
              未開啟的話，網站的功能可能無法正常運作。
            </span>
          </template>
        </div>
      </footer>
    </template>
    <v-dialog
      ref="alertDialog"
      v-model="alertDialog.open"
      width="500"
    >
      <v-card>
        <v-card-title
          v-show="alertDialog.title"
          class="headline"
        >
          {{ alertDialog.title }}
        </v-card-title>
        <v-card-text v-show="alertDialog.message">
          {{ alertDialog.message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <template v-if="alertDialog.btn.length > 0">
            <v-btn
              v-for="(btn, index) in alertDialog.btn"
              :key="index"
              :ref="'alertDialogBtn-' + index"
              :color="btn.btnColor"
              :outlined="btn.outlined"
              :depressed="btn.depressed"
              :loading="btn.btnIsLoading"
              @click="btn.btnClick"
            >
              {{ btn.btnText }}
            </v-btn>
          </template>
          <v-btn
            v-else
            ref="dialogBtn"
            color="primary"
            :autofocus="!alertDialog.open"
            :loading="alertDialog.loading"
            @click="alertDialog.donFun"
          >
            關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mdiEye, mdiEyeOff } from '@mdi/js'
import guestPurchase from '@/mixin/guestPurchase.js'
export default {
  mixins: [guestPurchase],
  props: [
    'hasContinue',
    'propStep',
    'phone',
    'mail',
    'open',
    'isLoading'
  ],
  data () {
    return {
      loading: false,
      icons: {
        mdiEye,
        mdiEyeOff
      },
      inputData: {
        phone: '',
        phoneRule: [() => true],
        password: '',
        passwordShow: false,
        passwordRule: [() => true],
        oldPassword: '',
        oldPasswordShow: false,
        oldPasswordRule: [() => true],
        verifiction: '',
        verifictionRule: [() => true],
        setPassword: '',
        setPasswordShow: false,
        setPasswordRule: [() => true],
        setPasswordAgain: '',
        setPasswordAgainShow: false,
        setPasswordAgainRule: [() => true],
        mail: '',
        mailRule: [() => true]
      },
      verifiction: {
        isCountDownIng: false,
        isSending: false,
        countDown: 0,
        countSecond: 180,
        reSetPasswordTimes: 0,
        Token: '',
        Jwt: '',
        buttonDisabled: true
      },
      step: {
        now: 'inputPhone',
        history: []
        // now: 'setPassword'
      },
      continueBtnIsLoading: false,
      continueBtnIsDisabled: false,
      alertDialog: {
        open: false,
        title: '',
        message: '',
        loading: false,
        donFun: () => {},
        btn: []
      },
      googleInfo: {
        isInit: null,
        timecount: 0,
        timeout: 10,
        canLogin: null,
        hasHash: null,
        hashParams: {},
        isLoading: null
      },
      appleInfo: {
      },
      reqBody: null
    }
  },
  computed: {
    ...mapGetters([
      'postBody', 'isGuestAgent'
    ]),
    phoneValidate () {
      return ['phoneValidation', 'guestValidation'].includes(this.step.now)
    },
    guestValidate () {
      return ['isGuestMemberLogin', 'guestValidation'].includes(this.step.now)
    }
  },
  watch: {
    isLoading (val) {
      this.loading = val
    },
    phone (val) {
      this.inputData.phone = val
      this.continueBtnIsDisabled = true
    },
    mail (val) {
      this.inputData.mail = val
      this.continueBtnIsDisabled = true
    },
    open (val) {
      if (!val) return
      this.continueBtnIsDisabled = false
      if (this.propStep) {
        this.step.now = this.propStep
      }
      if (['phoneValidation', 'guestValidation', 'mailValidation'].indexOf(this.propStep) > -1) {
        this.continueBtnIsDisabled = true
      }
      if (this.propStep === 'mailValidation') {
        this.inputData.mail = this.mail
      }
      if (this.propStep === 'phoneValidation' || this.propStep === 'guestValidation') {
        this.inputData.phone = this.phone
      }
    },
    propStep (val) {
      this.step.now = val
      this.step.history[0] = this.step.now
      if (['phoneValidation', 'guestValidation', 'mailValidation'].indexOf(val) > -1) {
        this.continueBtnIsDisabled = true
      }
      if (val === 'mailValidation') {
        this.inputData.mail = this.mail
      }
      if (val === 'phoneValidation' || val === 'guestValidation') {
        this.inputData.phone = this.phone
      }
    },
    '$auth.loggedIn' (val) {
      if (!val) { // 登出
        if (this.step.now === 'guestMemberSetPassword') {
          this.step.now = 'inputPhone'
          this.resetAll()
        }
      }
    }
  },
  async mounted () {
    await this.$set(this, 'reqBody', _.cloneDeep(this.postBody))
    if (this.reqBody &&
        Object.keys(this.reqBody).length > 0 &&
        this.reqBody.code && this.reqBody.state) {
      this.loading = true
      this.$store.commit('postBody', {})
      this.LoginWithApple()
    }
    if (this.$nuxt.$route && this.$nuxt.$route.hash) {
      this.loading = true
      this.googleInfo.hasHash = this.$nuxt.$route.hash.indexOf('google') > -1 // google登入導向回來
    } else {
      this.googleInfo.hasHash = false
    }
    if (this.$nuxt.$route.hash) {
      const regex = /([^&=]+)=([^&]*)/g; let m
      while (m = regex.exec(this.$nuxt.$route.hash)) {
        this.googleInfo.hashParams[decodeURIComponent(m[1])] = decodeURIComponent(m[2])
      }
    }
    if (process.client && this.googleInfo.hashParams && this.googleInfo.hashParams.access_token) {
      this.$auth.$storage.setLocalStorage('googleToken', this.googleInfo.hashParams.access_token)
    }
    this.checkGoogle()
    if (this.$nuxt.context.env.NODE_ENV_NAME !== 'ec') {
      this.verifiction.countSecond = 60
    }
    if (this.propStep) {
      this.step.now = this.propStep
    }

    if (this.phone) {
      this.inputData.phone = this.phone
    }
    if (this.mail) {
      this.inputData.mail = this.mail
    }
    if (['phoneValidation', 'guestValidation', 'mailValidation'].indexOf(this.step.now) > -1) {
      this.continueBtnIsDisabled = true
    }
    const setPasswordRule = async () => {
      const passwordRequired = value => !!value || '請輸入密碼'
      const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
      const passwordFormat = value => {
        const pattern = /^[\d|a-zA-Z]+$/
        return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
      }
      await this.$set(this.inputData, 'setPasswordRule', [passwordRequired, passwordLength, passwordFormat])
    }
    const setPasswordAgainRule = async () => {
      const passwordRequired = value => !!value || '請輸入確認密碼'
      const passwordCompare = value => value === this.inputData.setPassword || '兩次密碼不相同'
      await this.$set(this.inputData, 'setPasswordAgainRule', [passwordRequired, passwordCompare])
    }
    setPasswordRule()
    setPasswordAgainRule()
    this.step.history[0] = this.step.now
  },
  methods: {
    full2half (val) {
      if (!val) return ''
      let temp = ''
      for (let i = 0; i < val.toString().length; i++) {
        let charCode = val.toString().charCodeAt(i)
        if (charCode >= 65281 && charCode <= 65374) {
          charCode -= 65248
        } else if (charCode == 12288) { // 全形空白轉半形
          charCode = 32
        }
        temp = temp + String.fromCharCode(charCode)
      }
      return temp
    },
    checkGauthLoad () {
      const self = this
      if (self.googleInfo.timecount >= self.googleInfo.timeout) { // 逾時
        self.googleInfo.canLogin = false
        return
      }
      setTimeout(() => {
        if (self.googleInfo.timecount >= self.googleInfo.timeout) { // 逾時
          self.googleInfo.canLogin = false
          return
        }
        if (self.$gAuth.isInit !== null) {
          self.googleInfo.canLogin = self.$gAuth.isInit
          self.googleInfo.timecount = self.googleInfo.timeout
          return
        }
        self.googleInfo.timecount++
        self.checkGauthLoad()
      }, 1000)
    },
    checkSendTimes () {
      // if (this.$auth.$storage.getCookie('reSetPassword')) {
      //   this.verifiction.reSetPasswordTimes = this.$auth.$storage.getCookie('reSetPassword')
      // }
    },
    resetAll () {
      this.verifiction.isCountDownIng = false
      this.verifiction.isSending = false
      this.verifiction.countDown = 0
      this.verifiction.reSetPasswordTimes = 0
      this.verifiction.Token = ''
      this.verifiction.Jwt = ''
      this.verifiction.buttonDisabled = true
      this.continueBtnIsLoading = false
      this.continueBtnIsDisabled = false
      this.step.history.length = 0
      this.$refs.form?.reset()
      this.$refs.form?.resetValidation()
      this.resetData()
    },
    resetData () {
      Object.entries(this.inputData).map(([key, value]) => {
        if (key.slice(-4) === 'Rule') {
          this.$set(this.inputData, key, [() => true])
        } else if (key.slice(-4) === 'Show') {
          this.$set(this.inputData, key, false)
        } else {
          this.$set(this.inputData, key, '')
        }
      })
    },
    back () {
      const stepPrev = this.step.history.pop()
      const stepNow = this.step.history.slice(-1)[0]
      this.$set(this.step, 'now', stepNow)
      this.$emit('switchLoginType', null)
      if (stepPrev === 'forget') {
        this.continueBtnIsDisabled = false
      }
    },
    close () {
      this.$emit('close')
      this.resetAll()
    },
    /** 第一步驟，輸入電話號碼 */
    async stepInputPhoneContinue () {
      const setPhoneRule = async () => {
        const phoneRequired = value => !!value || '請輸入手機號碼'
        const phoneRule = value => {
          const pattern = new RegExp(/^09[0-9]{8}$/)
          return pattern.test(value) || '請輸入正確格式 0900123456'
        }
        await this.$set(this.inputData, 'phoneRule', [phoneRequired, phoneRule])
      }
      await setPhoneRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }
      try {
        const result = await this.$axios.get('/api/KingnetAccount/CheckIsGuestMemberByPhone', { params: { Phone: this.inputData.phone } })
        if (result.data.Data.IsGuestMember) {
          const isDeletedMember = await this.CheckIsDeletedKingnetMemberByPhone(this.inputData.phone)
          if (isDeletedMember) {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '您已刪除此帳號',
              type: 'error'
            })
            this.continueBtnIsLoading = false
            return Promise.reject()
          }
          this.step.now = 'isGuestMemberLogin'
          await this.sendPhoneVerifiction()
          this.continueBtnIsLoading = false
          return
        }

        const checkIsKingnetMember = await this.$axios.get('/api/Account/CheckIsKingnetMemberByPhone', { params: { Phone: this.inputData.phone } })
        if (checkIsKingnetMember.data?.Data) {
          this.step.now = 'isLogin'
          this.$emit('switchLoginType', 'login')
          this.continueBtnIsLoading = false
          return
        }

        const { data } = await this.apiSendRegisterVerifictionCode(1)
        this.verifiction.Token = data.Data.Token

        // 已發驗證碼
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '已發送驗證碼',
          type: 'success'
        })
        this.step.now = 'isRegister'
        this.$emit('switchLoginType', 'register')
        this.continueBtnIsLoading = false
        this.startVerifictionCountDown()
      } catch (error) {
        console.log(error)
        if (error.response.data.ErrorMessage &&
            error.response.data.ErrorMessage.Code === 403000) {
          // 電話錯誤！系統已經綁定過此電話
          this.step.now = 'isLogin'
          this.$emit('switchLoginType', 'login')
          this.continueBtnIsLoading = false
          return Promise.resolve()
        }
        this.continueBtnIsLoading = false
        return Promise.reject(error)
      }
    },
    /** 第二步驟，登入 */
    async stepLoginContinue () {
      if (this.step.now !== 'isLogin') return
      const setPasswordRule = async () => {
        const passwordRequired = value => !!value || '請輸入密碼'
        await this.$set(this.inputData, 'passwordRule', [passwordRequired])
      }

      await setPasswordRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }
      await this.$store.dispatch('login', {
        Account: this.inputData.phone,
        Password: this.inputData.password
      }).catch(error => {
        const errorObj = {
          isError: false,
          errorMessage: ''
        }
        switch (error.Code) {
          case 400001: // Password 不得為空。
            errorObj.isError = true
            errorObj.errorMessage = '密碼不得為空。'
            break
          case 401000: // 帳號或密碼錯誤
            errorObj.isError = true
            errorObj.errorMessage = '密碼錯誤'
            break
          default:
            break
        }
        if (errorObj.isError) {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: errorObj.errorMessage,
            type: 'error'
          })
        }
        this.continueBtnIsLoading = false
        this.$gaLogEvent('登入', '手機_失敗')
        return Promise.reject(error)
      })
      window.localStorage.setItem(
        'memberUpgradeAlertInfo',
        JSON.stringify({
          time: null,
          open: false
        })
      )
      // await this.$auth.fetchUser()
      this.continueBtnIsLoading = false
      this.$gaLogEvent('登入', '手機_成功')
      this.$emit('isLogin')
      this.resetAll()
    },
    async guestMemberLogin () {
      try {
        const setVerifictionRule = async () => {
          const verifictionRequired = value => !!value || '請輸入驗證碼'
          await this.$set(this.inputData, 'verifictionRule', [verifictionRequired])
        }

        await setVerifictionRule()
        if (!this.$refs.form.validate()) {
          this.continueBtnIsLoading = false
          return Promise.reject()
        }
        const result = await this.stepPhoneValidation()
        if (!result) {
          this.continueBtnIsLoading = false
          return Promise.reject()
        }
        await this.$store.dispatch('login', {
          Account: this.inputData.phone,
          Password: this.inputData.verifiction
        }).catch(error => {
          const errorObj = {
            isError: false,
            errorMessage: ''
          }
          switch (error.Code) {
            case 400001: // Password 不得為空。
              errorObj.isError = true
              errorObj.errorMessage = '密碼不得為空。'
              break
            case 401000: // 帳號或密碼錯誤
              errorObj.isError = true
              errorObj.errorMessage = '密碼錯誤'
              break
            default:
              break
          }
          if (errorObj.isError) {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: errorObj.errorMessage,
              type: 'error'
            })
          }
          this.continueBtnIsLoading = false
          return Promise.reject(error)
        })
        window.localStorage.setItem(
          'memberUpgradeAlertInfo',
          JSON.stringify({
            time: null,
            open: false
          })
        )
        await this.$store.dispatch('checkIsGuestMember', { Phone: this.inputData.phone })
        this.continueBtnIsLoading = false
        this.resetAll()
        this.step.now = 'guestMemberSetPassword'
      } catch (err) {
        console.log('err', err)
        this.continueBtnIsLoading = false
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '登入失敗',
          type: 'error'
        })
        return Promise.reject()
      }
    },
    /** 第二步驟，註冊 */
    async setVerifictionContinue () {
      if (this.step.now !== 'isRegister') {
        this.continueBtnIsLoading = false
        return
      }

      const setVerifictionRule = async () => {
        const verifictionRequired = value => !!value || '請輸入驗證碼'
        await this.$set(this.inputData, 'verifictionRule', [verifictionRequired])
      }

      await setVerifictionRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }

      // 驗證碼驗證
      if (!this.verifiction.Token) {
        const data = await this.apiSendRegisterVerifictionCode()
          .catch(() => this.continueBtnIsLoading = false)
        this.verifiction.Token = data.Data.Token
      }
      this.$axios.setHeader('RegisterVerificationToken', this.verifiction.Token)
      const { data } = await this.$axios.post('/api/KingnetAccount/VerifictionCode', { Code: this.inputData.verifiction })
        .catch(async error => {
          this.$gaLogEvent('註冊', '註冊_失敗')
          const errorObj = error.response.data.ErrorMessage || {}
          const errorCode = errorObj.Code || null
          const errorReturnObj = {
            isError: false,
            message: '',
            donFun: () => {}
          }
          switch (errorCode) {
            case 400005: // 驗證碼不符
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證碼不符'
              break
            case 400008: // 驗證超過三次
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證超過三次，請重新發送驗證碼'
              this.continueBtnIsDisabled = true
              // this.$axios.setHeader('RegisterVerificationToken', false)
              // try {
              //   await this.apiSendRegisterVerifictionCode()
              // } catch (error) {
              // }
              break
            case 401004: // 驗證超時
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證碼失效，請重新發送驗證碼'
              this.continueBtnIsDisabled = true
              break
            default:
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證錯誤'
              this.continueBtnIsDisabled = true
              break
          }
          if (errorReturnObj.isError) {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: errorReturnObj.message,
              type: 'error'
            })
          }
          this.verifiction.Token = error.response.data.Data.Token
          if (errorCode === 400008) { // 驗證超過三次
            this.verifiction.Token = ''
          }
          this.$axios.setHeader('RegisterVerificationToken', false)
          this.continueBtnIsLoading = false
          return Promise.reject(error)
        })
      this.$gaLogEvent('註冊', '註冊_成功')
      this.$axios.setHeader('RegisterVerificationToken', data.Data.Token)
      this.step.now = 'setPassword'
      this.continueBtnIsLoading = false
    },
    /** 第三步驟，設定密碼 */
    async setSetPasswordContinue () {
      if (this.step.now !== 'setPassword') {
        this.continueBtnIsLoading = false
        return
      }

      const setPasswordRule = async () => {
        const passwordRequired = value => !!value || '請輸入密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
        const passwordFormat = value => {
          const pattern = /^[\d|a-zA-Z]+$/
          return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
        }
        await this.$set(this.inputData, 'setPasswordRule', [passwordRequired, passwordLength, passwordFormat])
      }
      const setPasswordAgainRule = async () => {
        const passwordRequired = value => !!value || '請輸入確認密碼'
        const passwordCompare = value => value === this.inputData.setPassword || '兩次密碼不相同'
        await this.$set(this.inputData, 'setPasswordAgainRule', [passwordRequired, passwordCompare])
      }

      await setPasswordRule()
      await setPasswordAgainRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }

      await this.$axios.post('/api/KingnetAccount/SetPasswordByServiceAccountTransfer', { Password: this.inputData.setPassword })
        .catch(error => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '密碼設定失敗',
            type: 'error'
          })
          this.continueBtnIsLoading = false
          return Promise.reject(error)
        })
      this.continueBtnIsLoading = false
      this.$axios.setHeader('RegisterVerificationToken', false)
      await this.$store.dispatch('login', {
        Account: this.inputData.phone,
        Password: this.inputData.setPassword
      }).catch(error => {
        return Promise.reject(error)
      })
      window.localStorage.setItem(
        'memberUpgradeAlertInfo',
        JSON.stringify({
          time: null,
          open: false
        })
      )
      // await this.$auth.fetchUser()
      this.continueBtnIsLoading = false
      this.$emit('isLogin', 'register')
      this.resetAll()
      // await this.$nuxt.$router.replace('/')
      // await this.$store.dispatch('registerSuccess', {isOpen: true, scrollTop: true})
    },
    /** 忘記密碼 */
    async setForgetContinue () {
      if (this.step.now !== 'forget') {
        this.continueBtnIsLoading = false
        return
      }

      const setVerifictionRule = async () => {
        const verifictionRequired = value => !!value || '請輸入驗證碼'
        this.$set(this.inputData, 'verifictionRule', [verifictionRequired])
      }

      await setVerifictionRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }
      this.$axios.setHeader('RegisterVerificationToken', this.verifiction.Token)
      const { data } = await this.$axios.post('/api/KingnetAccount/VerifictionReSetPasswordCode', { Code: this.inputData.verifiction })
        .catch(async error => {
          const errorObj = error.response.data.ErrorMessage || {}
          const errorCode = errorObj.Code || null
          const errorReturnObj = {
            isError: false,
            message: '',
            donFun: () => {}
          }
          switch (errorCode) {
            case 400005: // 驗證碼不符
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證碼不符'
              break
            case 400008: // 驗證超過三次
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證超過三次，請重新發送驗證碼'
              this.continueBtnIsDisabled = true
              break
            case 401005: // 驗證碼不符
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證碼不符'
              break
            case 401004: // 驗證超時
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證碼失效，請重新發送驗證碼'
              this.continueBtnIsDisabled = true
              break
            case 401007: // 5分鐘內最多只能發送3次驗證訊息。 // TODO
              errorReturnObj.isError = true
              errorReturnObj.message = this.$nuxt.context.env.NODE_ENV_NAME === 'local' ? '5分鐘內最多只能發送3次驗證訊息。' : '24小時內最多只能發送3次驗證訊息。'
              this.continueBtnIsDisabled = false
              break
            default:
              errorReturnObj.isError = true
              errorReturnObj.message = '驗證錯誤'
              this.continueBtnIsDisabled = true
              break
          }
          if (errorReturnObj.isError) {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: errorReturnObj.message,
              type: 'error'
            })
          }
          this.verifiction.Token = error.response.data.Data.Token
          this.$axios.setHeader('RegisterVerificationToken', false)
          this.continueBtnIsLoading = false
          return Promise.reject(error)
        })
      this.verifiction.Token = data.Data.Token
      this.$axios.setHeader('RegisterVerificationToken', false)
      this.inputData.verifiction = ''
      this.step.now = 'reSetPassword'
      this.continueBtnIsLoading = false
    },
    /** 重設密碼 */
    async setReSetForgetContinue () {
      if (this.step.now !== 'reSetPassword') {
        this.continueBtnIsLoading = false
        return
      }

      const setPasswordRule = async () => {
        const passwordRequired = value => !!value || '請輸入密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
        const passwordFormat = value => {
          const pattern = /^[\d|a-zA-Z]+$/
          return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
        }
        await this.$set(this.inputData, 'setPasswordRule', [passwordRequired, passwordLength, passwordFormat])
      }
      const setPasswordAgainRule = async () => {
        const passwordRequired = value => !!value || '請輸入確認密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '請輸入確認密碼'
        const passwordCompare = value => value === this.inputData.setPassword || '兩次密碼不相同'
        await this.$set(this.inputData, 'setPasswordAgainRule', [passwordRequired, passwordLength, passwordCompare])
      }

      await setPasswordAgainRule()
      await setPasswordRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }

      this.$axios.setHeader('RegisterVerificationToken', this.verifiction.Token)
      await this.$axios.post('/api/KingnetAccount/ReNewPassword', { Password: this.inputData.setPassword })
        .catch(error => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '密碼設定失敗',
            type: 'error'
          })
          this.continueBtnIsLoading = false
          return Promise.reject(error)
        })
      this.$store.dispatch('toast', {
        isOpen: true,
        text: '密碼變更成功',
        type: 'success'
      })
      this.inputData.setPassword = ''
      this.inputData.setPasswordAgain = ''
      this.continueBtnIsLoading = false
      this.step.now = 'isLogin'
    },
    /** 手機驗證 */
    async stepPhoneValidation () {
      if (!this.phoneValidate && !this.step.now === 'isGuestMemberLogin') {
        this.continueBtnIsLoading = false
        return
      }

      const setVerifictionRule = async () => {
        const verifictionRequired = value => !!value || '請輸入驗證碼'
        const verifictionLength = value => String(value).length <= 6 || '請輸入正確驗證碼'
        this.$set(this.inputData, 'verifictionRule', [verifictionRequired, verifictionLength])
      }

      await setVerifictionRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }
      try {
        const postData = {
          Jwt: this.verifiction.Jwt,
          Code: this.inputData.verifiction,
          Phone: this.inputData.phone
        }
        if (this.guestValidate) postData.Source = 'EcWeb'
        const api = this.guestValidate ? '/api/Verification/SMSAuthenticateForGuest' : '/api/Verification/SMSAuthenticate'
        const { data } = await this.$axios.post(api, postData)
        if (data.Data.Success) {
          // 成功
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '驗證成功',
            type: 'success'
          })
          this.continueBtnIsLoading = false
          if (this.step.now === 'guestValidation') {
            this.$emit('isLogin', 'guestValidation')
            this.$store.commit('setCreateGuestAccountData',
              {
                Phone: this.inputData.phone,
                Code: this.inputData.verifiction,
                VerificationCode: data.Data.VerificationCode
              }
            )
          } else if (this.step.now === 'isGuestMemberLogin') {
            return true
          } else {
            this.$auth.setUser({
              ...this.$auth.user,
              APhone: this.inputData.phone
            })
            this.$emit('isLogin', 'phoneValidation')
          }
          this.resetAll()
        } else {
          this.continueBtnIsLoading = false
          // 失敗
          if (data.Data.FailCount < 3) {
            this.verifiction.Jwt = data.Data.Jwt
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '驗證失敗',
              type: 'error'
            })
          } else { // 驗證超過三次
            this.continueBtnIsDisabled = true
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '驗證超過三次，請重新發送驗證碼',
              type: 'error'
            })
          }
          return false
        }
      } catch (error) {
        this.continueBtnIsLoading = false
        let errorText = '驗證失敗'
        if (error.response.data.ErrorMessage?.Code === 400000) {
          if (error.response.data.ErrorMessage.Description === 'jwt已過期') {
            errorText = '驗證碼過期，請重新發送驗證碼'
          } else if (error.response.data.ErrorMessage.Description === 'phone不符') {
            errorText = '手機號碼不符合，請填寫正確號碼'
          }
        }
        this.$store.dispatch('toast', {
          isOpen: true,
          text: errorText,
          type: 'error'
        })
        return Promise.reject()
      }
      this.continueBtnIsLoading = false
    },
    /** E-mail 驗證 */
    async stepMailValidation () {
      if (this.step.now !== 'mailValidation') {
        this.continueBtnIsLoading = false
        return
      }

      const setVerifictionRule = async () => {
        const verifictionRequired = value => !!value || '請輸入驗證碼'
        const verifictionLength = value => String(value).length <= 6 || '請輸入正確驗證碼'
        this.$set(this.inputData, 'verifictionRule', [verifictionRequired, verifictionLength])
      }
      await setVerifictionRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }

      try {
        const { data } = await this.$axios.post('/api/Verification/EmailAuthenticate', {
          Jwt: this.verifiction.Jwt,
          Code: this.inputData.verifiction,
          Email: this.inputData.mail
        })
        if (data.Data.Success) {
          await this.$auth.setUser({
            ...this.$auth.user,
            AEmail: this.inputData.mail
          })
          // 成功
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '驗證成功',
            type: 'success'
          })
          this.continueBtnIsLoading = false
          this.$emit('isLogin', 'mailValidation')
          this.resetAll()
        } else {
          // 失敗
          if (data.Data.FailCount < 3) {
            this.verifiction.Jwt = data.Data.Jwt
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '驗證失敗',
              type: 'error'
            })
          } else { // 驗證超過三次
            this.continueBtnIsDisabled = true
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '驗證超過三次，請重新發送驗證碼',
              type: 'error'
            })
          }
        }
      } catch (error) {

      }
    },
    /** 變更密碼 */
    async stepChangePassword () {
      if (this.step.now !== 'changePassword') {
        this.continueBtnIsLoading = false
        return
      }

      const setOldPasswordRule = async () => {
        const passwordRequired = value => !!value || '請輸入舊密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '請輸入舊密碼'
        await this.$set(this.inputData, 'oldPasswordRule', [passwordRequired, passwordLength])
      }
      const setPasswordRule = async () => {
        const passwordRequired = value => !!value || '請輸入新密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
        const passwordFormat = value => {
          const pattern = /^[\d|a-zA-Z]+$/
          return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
        }
        await this.$set(this.inputData, 'setPasswordRule', [passwordRequired, passwordLength, passwordFormat])
      }
      const setPasswordAgainRule = async () => {
        const passwordRequired = value => !!value || '請輸入確認密碼'
        const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
        const passwordCompare = value => value === this.inputData.setPassword || '與新密碼不相符'
        const passwordFormat = value => {
          const pattern = /^[\d|a-zA-Z]+$/
          return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
        }
        await this.$set(this.inputData, 'setPasswordAgainRule', [passwordRequired, passwordLength, passwordFormat, passwordCompare])
      }

      await setOldPasswordRule()
      await setPasswordRule()
      await setPasswordAgainRule()
      if (!this.$refs.form.validate()) {
        this.continueBtnIsLoading = false
        return Promise.reject()
      }

      this.alertDialog.title = '密碼變更'
      this.alertDialog.message = '密碼變更後無法還原，確定要變更密碼嗎？'
      this.alertDialog.btn = [
        {
          btnText: '取消',
          btnColor: '',
          depressed: true,
          outlined: false,
          btnClick: () => {
            this.alertDialog.open = false
          }
        },
        {
          btnText: '確定變更',
          btnColor: 'primary',
          depressed: true,
          btnIsLoading: false,
          btnClick: async () => {
            this.alertDialog.btn[1].btnIsLoading = true
            try {
              await this.$axios.put('/api/KingnetAccount/ChangePassword', {
                Password: this.inputData.oldPassword,
                NewPassword: this.inputData.setPassword
              })
              this.$store.dispatch('toast', {
                isOpen: true,
                text: '變更密碼成功',
                type: 'success'
              })
              await this.$emit('isLogin', 'changePassword')
              this.alertDialog.loading = false
              this.alertDialog.open = false
              this.continueBtnIsLoading = false
              this.resetAll()
            } catch (error) {
              const errorObj = {
                isError: false,
                errorMessage: ''
              }
              switch (error.response.data.ErrorMessage.Code) {
                case 401000: // 舊密碼錯誤
                  errorObj.isError = true
                  errorObj.errorMessage = '舊密碼錯誤'
                  break
                default:
                  errorObj.isError = true
                  errorObj.errorMessage = '密碼設定失敗'
                  break
              }
              if (errorObj.isError) {
                this.$store.dispatch('toast', {
                  isOpen: true,
                  text: errorObj.errorMessage,
                  type: 'error'
                })
              }
              this.alertDialog.btn[1].btnIsLoading = false
              this.alertDialog.open = false
              this.continueBtnIsLoading = false
            }
          }
        }
      ]
      this.alertDialog.open = true
      const self = this
      this.$nextTick(() => {
        setTimeout(() => {
          if (self.$refs['alertDialogBtn-1']) {
            self.$refs['alertDialogBtn-1'][0].$el.focus()
          }
        }, 0)
      })
    },
    /** 訪客設定密碼 */
    async guestMemberSetPassword () {
      try {
        const setPasswordRule = async () => {
          const passwordRequired = value => !!value || '請輸入新密碼'
          const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
          const passwordFormat = value => {
            const pattern = /^[\d|a-zA-Z]+$/
            return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
          }
          await this.$set(this.inputData, 'setPasswordRule', [passwordRequired, passwordLength, passwordFormat])
        }
        const setPasswordAgainRule = async () => {
          const passwordRequired = value => !!value || '請輸入確認密碼'
          const passwordLength = value => String(value).length >= 8 && String(value).length <= 12 || '密碼須為英數8至12位數'
          const passwordCompare = value => value === this.inputData.setPassword || '與新密碼不相符'
          const passwordFormat = value => {
            const pattern = /^[\d|a-zA-Z]+$/
            return pattern.test(String(value).toLowerCase()) || '密碼須為英數8至12位數'
          }
          await this.$set(this.inputData, 'setPasswordAgainRule', [passwordRequired, passwordLength, passwordFormat, passwordCompare])
        }
        await setPasswordRule()
        await setPasswordAgainRule()
        if (!this.$refs.form.validate()) {
          this.continueBtnIsLoading = false
          return Promise.reject()
        }
        await this.$axios.post('/api/KingnetAccount/SetNewPasswordByGuest', {
          Password: this.inputData.setPassword
        })
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '設定密碼成功',
          type: 'success'
        })
        this.$store.commit('setIsGuestMember', false)
        await this.$emit('isLogin', 'setPassword')
        this.alertDialog.loading = false
        this.alertDialog.open = false
        this.continueBtnIsLoading = false
        this.resetAll()
      } catch (err) {
        console.log('err', err)
        this.alertDialog.loading = false
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '設定失敗，請稍後再試',
          type: 'success'
        })
        return Promise.reject()
      }
    },
    async clickContinue () {
      if (this.continueBtnIsDisabled) return
      if (this.continueBtnIsLoading) return
      this.continueBtnIsLoading = true
      try {
        switch (this.step.now) {
          case 'inputPhone': // 第一步驟，輸入電話號碼
            await this.stepInputPhoneContinue()
            this.$FBConversionAPI({ event_name: '會員登入下一步', user_data: { phone: this.inputData.phone } })
            break
          case 'isLogin': // 第二步驟，登入
            await this.stepLoginContinue()
            this.$FBConversionAPI({ event_name: '會員確定登入', user_data: { phone: this.inputData.phone } })
            break
          case 'isRegister': // 第二步驟，註冊
            await this.setVerifictionContinue()
            break
          case 'setPassword': // 第三步驟，設定密碼
            await this.setSetPasswordContinue()
            break
          case 'forget': // 忘記密碼
            await this.setForgetContinue()
            break
          case 'reSetPassword': // 忘記密碼
            await this.setReSetForgetContinue()
            break
          case 'phoneValidation': // 手機驗證
            await this.stepPhoneValidation()
            break
          case 'guestValidation': // 手機驗證
            await this.stepPhoneValidation()
            return
          case 'isGuestMemberLogin': // 手機驗證
            await this.guestMemberLogin()
            break
          case 'guestMemberSetPassword': // 設定密碼
            await this.guestMemberSetPassword()
            return
          case 'mailValidation': // E-mail 驗證
            await this.stepMailValidation()
          case 'changePassword': // 變更密碼
            await this.stepChangePassword()
          default:
            this.continueBtnIsLoading = false
            break
        }
        this.step.history.push(this.step.now)
      } catch (error) {

      }
    },
    async apiSendRegisterVerifictionCode (step) {
      try {
        const response = await this.$axios.post('/api/KingnetAccount/SendRegisterVerifictionCode', { Phone: this.inputData.phone })
        this.continueBtnIsDisabled = false
        return { data: response.data }
      } catch (error) {
        const errorObj = error.response.data.ErrorMessage || {}
        const errorCode = errorObj.Code || null
        const errorReturnObj = {
          isError: false,
          title: '',
          message: '',
          donFun: () => {}
        }
        switch (errorCode) {
          case 400001: // Phone必須是包含加號之E164格式電話號碼(可以是null或空字串),regex: ^09[0-9]{8}$
            break
          case 403000: // 電話錯誤！系統已經綁定過此電話
            if (step !== 1) {
              errorReturnObj.isError = true
              errorReturnObj.title = '此帳號已註冊'
              errorReturnObj.message = '此帳號已註冊，將導至登入流程'
              errorReturnObj.donFun = () => {
                this.step.now = 'isLogin'
                this.alertDialog.open = false
              }
            }
            break
          case 401007: // 5分鐘內最多只能發送3次驗證訊息。
            errorReturnObj.isError = true
            errorReturnObj.title = '簡訊相關錯誤'
            errorReturnObj.message = this.$nuxt.context.env.NODE_ENV_NAME === 'local' ? '5分鐘內最多只能發送3次驗證訊息。' : '24小時內最多只能發送3次驗證訊息。'
            errorReturnObj.donFun = () => {
              this.alertDialog.open = false
            }
            break
          case 401010: // 5分鐘內最多只能發送3次驗證訊息。
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '您已刪除此帳號',
              type: 'error'
            })
            break
          default:
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '請稍候再嘗試',
              type: 'error'
            })
            break
        }
        this.alertDialog = {
          ...this.alertDialog,
          ...errorReturnObj,
          open: errorReturnObj.isError
        }
        return Promise.reject(error)
      }
    },
    /** 點擊「忘記密碼」 */
    async clickForget () {
      this.$gaLogEvent('忘記密碼', '')
      this.step.now = 'forget'
      this.step.history.push('forget')
      this.continueBtnIsDisabled = true
      // await this.apiReSetPasswordVerifictionCode()
    },
    async clickSendVerifiction () {
      if (this.verifiction.isCountDownIng) return
      this.verifiction.isSending = true
      if (this.step.now === 'isRegister') {
        this.sendRegisterVerifiction() // 發送綁定帳號驗證碼
      } else if (this.step.now === 'forget') {
        this.sendForgetVerifiction() // 發送重設密碼驗證碼
      } else if (this.phoneValidate) {
        this.sendPhoneVerifiction() // TODO
      } else if (this.step.now === 'mailValidation') {
        this.sendMailVerifiction() // TODO
      }
    },
    /** 發送綁定帳號驗證碼 */
    async sendRegisterVerifiction () {
      try {
        const { data } = await this.apiSendRegisterVerifictionCode()
        this.verifiction.Token = data.Data.Token
        this.$gaLogEvent('發送驗證碼', '驗證頁_click_發送驗證碼')
        // 已發驗證碼
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '已發送驗證碼',
          type: 'success'
        })
        this.startVerifictionCountDown()
        this.verifiction.isSending = false
      } catch (error) {
        this.verifiction.isSending = false
      }
    },
    async apiReSetPasswordVerifictionCode () {
      try {
        const { data } = await this.$axios.post('/api/KingnetAccount/SendReSetPasswordVerifictionCode', { Phone: this.inputData.phone })
        this.continueBtnIsDisabled = false
        this.verifiction.Token = data.Data.Token
        this.$gaLogEvent('發送驗證碼', '驗證頁_click_發送驗證碼')
        // if (this.verifiction.reSetPasswordTimes < 3) {
        //   this.verifiction.reSetPasswordTimes++
        // }
        // 已發驗證碼
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '已發送驗證碼',
          type: 'success'
        })
        // this.$auth.$storage.setCookie('reSetPassword', this.verifiction.reSetPasswordTimes, { expires: 1 })
        this.startVerifictionCountDown()
        this.verifiction.isSending = false
      } catch (error) {
        const errorObj = error.response.data.ErrorMessage || {}
        const errorCode = errorObj.Code || null
        const errorReturnObj = {
          isError: false,
          title: '',
          message: '',
          donFun: () => {}
        }
        switch (errorCode) {
          case 401007: // 5分鐘內最多只能發送3次驗證訊息。
            errorReturnObj.isError = true
            errorReturnObj.title = '簡訊相關錯誤'
            errorReturnObj.message = this.$nuxt.context.env.NODE_ENV_NAME === 'local' ? '5分鐘內最多只能發送3次驗證訊息。' : '24小時內最多只能發送3次驗證訊息。'
            errorReturnObj.donFun = () => {
              this.alertDialog.open = false
            }
            break
          default:
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '請稍候再嘗試',
              type: 'error'
            })
            break
        }
        this.alertDialog = {
          ...this.alertDialog,
          ...errorReturnObj,
          open: errorReturnObj.isError
        }
        this.verifiction.isSending = false
        return Promise.reject(error)
      }
    },
    /** 發送重設密碼驗證碼 */
    async sendForgetVerifiction () {
      await this.apiReSetPasswordVerifictionCode()
    },
    async apiSendSMSAuthenticate () {
      try {
        const postData = {
          Phone: this.inputData.phone
        }
        let api = ''
        if (this.isGuestAgent) {
          postData.ServiceId = this.$nuxt.$route.params.service
          api = '/api/Verification/SendSMSAuthenticateForGuestAgent'
        } else if (this.guestValidate) {
          api = '/api/Verification/SendSMSAuthenticateForGuest'
        } else {
          api = '/api/Verification/SendSMSAuthenticate'
        }
        const { data } = await this.$axios.post(api, postData)
        this.$gaLogEvent('發送驗證碼', '驗證頁_click_發送驗證碼')
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '已發送驗證碼',
          type: 'success'
        })
        this.verifiction.Jwt = data.Data.Jwt
        this.startVerifictionCountDown()
        this.verifiction.isSending = false
        this.continueBtnIsDisabled = false
      } catch (error) {
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '驗證碼發送失敗',
          type: 'error'
        })
      }
    },
    /** 發送手機驗證碼 */
    async sendPhoneVerifiction () {
      try {
        if (this.inputData.phone !== this.phone && this.step.now === 'guestValidation') {
          const isAvaliablePhoneNumber = await this.checkIsAvaliablePhoneNumber(this.inputData.phone)
          if (!isAvaliablePhoneNumber) {
            this.verifiction.isSending = false
            return
          }
          this.$emit('updatePhone', this.inputData.phone)
        }
        const setPhoneRule = async () => {
          const phoneRequired = value => !!value || '請輸入手機號碼'
          const phoneRule = value => {
            const pattern = new RegExp(/^09[0-9]{8}$/)
            return pattern.test(value) || '請輸入正確格式 0900123456'
          }
          await this.$set(this.inputData, 'phoneRule', [phoneRequired, phoneRule])
        }
        await setPhoneRule()

        if (!this.$refs.form.validate()) {
          this.verifiction.isSending = false
          return
        }
        this.verifiction.isSending = true
        await this.apiSendSMSAuthenticate()
      } catch (err) {
        this.verifiction.isSending = false
      }
    },
    countDown () {
      if (this.verifiction.countDown <= 0) {
        this.verifiction.isCountDownIng = false
        return
      }
      const self = this
      setTimeout(() => {
        this.verifiction.countDown--
        this.countDown()
      }, 1000)
    },
    startVerifictionCountDown () {
      this.verifiction.countDown = this.verifiction.countSecond
      this.verifiction.isCountDownIng = true
      this.countDown()
    },
    /** 發送 E-mail 驗證碼 */
    async sendMailVerifiction () {
      this.verifiction.isSending = true
      try {
        const { data } = await this.$axios.post('/api/Verification/SendEmailAuthenticate', { Email: this.inputData.mail })
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '已發送驗證碼',
          type: 'success'
        })
        this.verifiction.Jwt = data.Data.Jwt
        this.startVerifictionCountDown()
        this.verifiction.isSending = false
        this.continueBtnIsDisabled = false
      } catch (error) {
        this.verifiction.isSending = false
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '驗證碼發送失敗',
          type: 'error'
        })
      }
    },
    /** 點擊清除 */
    clickClear (key) {
      this.inputData[key] = ''
      this.continueBtnIsDisabled = true
      this.verifiction.isCountDownIng = false
      this.verifiction.isSending = false
      this.verifiction.countDown = 0
    },
    async GoogleLoginIn () {
      if (process.client && this.$auth.$storage.getState('toRoute')) {
        sessionStorage.setItem('toRoute', JSON.stringify(this.$auth.$storage.getState('toRoute')))
      }
      const clientId = '716724447213-tnuoobvaohn4enqvscur6ncr39me9f78.apps.googleusercontent.com'
      const redirectUri = window.location.origin + '/login'
      const scope = 'openid+profile+email'
      const state = 'GOOGLbdgsqat'
      const include_granted_scopes = 'true'
      const response_type = 'token'
      const flowName = 'GeneralOAuthFlow'
      const prompt = 'select_account'

      const uri = `https://accounts.google.com/o/oauth2/v2/auth/identifier?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&include_granted_scopes=${include_granted_scopes}&response_type=${response_type}&flowName=${flowName}&prompt=${prompt}`
      window.location.href = uri
    },
    checkGoogle () {
      const self = this
      if (this.googleInfo.hashParams.access_token) {
        const xhr = new XMLHttpRequest()
        xhr.open('GET',
          'https://www.googleapis.com/oauth2/v2/userinfo')
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.googleInfo.hashParams.access_token)
        xhr.onreadystatechange = function (e) {
          if (xhr.readyState === 4 && xhr.status === 200) {
            const responseObject = JSON.parse(xhr.response)
            self.LoginWithGoogle({
              userId: responseObject.id,
              displayName: responseObject.name,
              email: responseObject.email,
              imageUrl: responseObject.picture,
              gender: ''
            })
            // use postMessage to send response to opening window and close or whatever you want to do with it
          } else if (xhr.readyState === 4 && xhr.status === 401) {
            // Token invalid, so prompt for user permission.
            self.oauth2SignIn()
          }
        }
        xhr.send(null)
      } else {

      }
    },
    async LoginWithGoogle (profile) {
      try {
        await this.$store.dispatch('thirdLogin', {
          UserType: 'KingnetGoogle',
          Account: profile.userId,
          IdToken: this.googleInfo.hashParams.access_token
        })
        console.log('after error')
        if (process.client) {
          this.$auth.$storage.setState('googleEmail', profile.email)
        }
        window.localStorage.setItem(
          'memberUpgradeAlertInfo',
          JSON.stringify({
            time: null,
            open: false
          })
        )
        this.$gaLogEvent('登入', 'Google_成功')
        this.$emit('isLogin')
      } catch (error) {
        console.log('google error', error)
        this.$gaLogEvent('登入', 'Google_失敗')
        this.$nuxt.$router.replace('/login')
        this.$auth.$storage.removeLocalStorage('googleToken')
        this.continueBtnIsLoading = false
        this.googleInfo.hasHash = false
        this.loading = false
      }
    },
    async AppleLoginIn () {
      if (process.client && this.$auth.$storage.getState('toRoute')) {
        sessionStorage.setItem('toRoute', JSON.stringify(this.$auth.$storage.getState('toRoute')))
      }
      try {
        const routeData = this.$nuxt.$router.resolve({
          name: 'login'
        })
        const redirectUri = location.origin + routeData.resolved.fullPath
        const { data } = await this.$serviceApi.post('/serviceApi/appleSignIn', { redirectUri })
        location.href = data
      } catch (error) {
        console.log(error.response)
      }
    },
    // apple 登入
    async LoginWithApple () {
      this.loading = true
      try {
        const routeData = this.$nuxt.$router.resolve({
          name: 'login'
        })
        const appleData = await this.$serviceApi.post('/serviceApi/appleAfterSignin', {
          ...this.reqBody,
          redirectUri: location.origin + routeData.resolved.fullPath,
          state: this.reqBody.state
        })
        // 登入
        await this.$store.dispatch('thirdLogin', {
          UserType: 'KingnetApple',
          Account: appleData.data.sub,
          IdToken: appleData.data.id_token,
          UserId: appleData.data.sub
        })
        window.localStorage.setItem(
          'memberUpgradeAlertInfo',
          JSON.stringify({
            time: null,
            open: false
          })
        )
        this.$gaLogEvent('登入', 'Apple_成功')
        this.$emit('isLogin')
      } catch (error) {
        this.loading = false
        this.$gaLogEvent('登入', 'Apple_失敗')
      }
    },
    inputValidate (rule) {
      if (rule.length > 1) {
        this.$refs.form.validate()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-register-area {
  max-height: 100vh;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow-y: auto;
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 300px;
  }
}
header {
  position: relative;
  text-align: center;
  padding-left: var(--safe-area-inset-left);
  padding-right: var(--safe-area-inset-right);
  p {
    margin: 6px auto 0;
    max-width: 315px;
    color: #999999;
    font-size: pxTorem(16px);
    line-height: pxTorem(22px);
    &.left {
      text-align: left;
    }
  }
  > i {
    position: absolute;
    top: 0;
    top: var(--safe-area-inset-top);
    padding: 10px;
    font-size: pxTorem(18px);
    line-height: pxTorem(22px);
    cursor: pointer;
  }
  i.back {
    left: -2px;
  }
  i.close {
    right: -10px;
    right: var(--safe-area-inset-right);
  }
}
.login-register-area__title {
  color: $mainColor;
  font-weight: bold;
}
p.register-notice {
  background-color: $lightGreenColor;
  padding: 16px;
  margin-bottom: 24px;
  font-size: pxTorem(17px);
  line-height: pxTorem(24px);
}
.item {
  &.verifiction {
    span.label {
      width: 100%;
    }
    .btn {
      height: auto;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
      &.is-sending {
        font-weight: 400;
      }
    }
  }
  & + .item {
    margin-top: 24px;
  }
  &.flex-item {
    $inputHeiight: 56px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    span.label {
      flex: none;
      width: 100%;
    }
    .append-outer {
      flex: none;
      margin-left: 10px;
      height: $inputHeiight;
    }
  }
  .label {
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
    color: $fontColor;
  }
  .input {
    color: #D2D2D2;
    ::v-deep {
      .v-input__append-outer {
        $height: 56px;
        margin-top: 0;
        margin-bottom: 0;
        line-height: $height;
        height: $height;
      }
    }
  }
  .append-outer {
    height: auto;
  }
  span.label {
    display: block;
  }
  ::v-deep {
    label.v-label {
      color: #999999;
    }
  }
}
.login-register-area {
  footer {
    text-align: center;
    .btn {
      height: auto;
      padding: 17px 75px;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
    }
    p {
      color: #999999;
      font-size: pxTorem(18px);
      line-height: pxTorem(25px);
      font-weight: 400;
    }
    .social-login {
      border: 1px solid #000;
      height: auto;
      text-transform: capitalize;
      border-radius: 8px;
      img {
        height: auto;
        width: 32px;
      }
    }
    .google-login {
      border-color: $mainColor;
    }
  }
}
span.forget {
  color: $mainColor;
  font-size: pxTorem(16px);
  line-height: pxTorem(22px);
  font-weight: bold;
  margin-top: 8px;
  display: inline-block;
  cursor: pointer;
}
.social-btn {
  > span {
    display: block;
    width: 90%;
    margin: 20px auto;
    color: $errorColor;
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  $googleLoginBtnHeight: 44px;
  $googleLoginBtnBottom: 40px;
  $googleLoginBtnGroupHeight: $googleLoginBtnHeight * 2 + 20px + 20px + $googleLoginBtnBottom;
  $inputHeight: 44px;
  .login-register-area {
    min-height: calc(100vh - #{$headerHeightMobile});
    min-height: calc(var(--vh, 1vh) * 100 - #{$headerHeightMobile});
    height: 100%;
    padding: 30px 15px $googleLoginBtnGroupHeight;
    padding-left: calc(15px + var(--safe-area-inset-left));
    padding-right: calc(15px + var(--safe-area-inset-right));
  }
  header {
    margin-bottom: 40px;
  }
  .login-register-area .content {
    margin-bottom: 20px;
  }
  .login-register-area__title {
    font-size: pxTorem(16px);
    line-height: pxTorem(22px);
  }
  .login-register-area .item {
    .label {
      margin-bottom: 5px;
      font-weight: 400;
    }
    ::v-deep {
      .v-input__slot {
        min-height: $inputHeight;
      }
      label.v-label {
        top: 0;
        height: $inputHeight;
        line-height: $inputHeight;
      }
      .v-input__append-inner {
        top: 0;
        height: $inputHeight;
        line-height: $inputHeight;
        margin: 0;
        align-items: center;
      }
    }
  }
  .item {
    &.verifiction {
      display: block;
      .input {
        display: block;
        margin-right: 0;
        margin-bottom: 25px;
      }
      .btn {
        display: block;
        width: 85%;
        margin: 0 auto;
        line-height: $inputHeight;
        min-height: $inputHeight;
        font-size: pxTorem(16px);
        line-height: pxTorem(22px);
      }
    }
    &.flex-item {
      .append-outer {
        height: 44px;
      }
    }
  }
  .login-register-area footer {
    .btn {
      min-width: auto;
      width: 85%;
      padding: 11px;
    }
    p {
      position: relative;
      margin-top: 0px;
      margin-bottom: 0;
      padding: 0 10px;
      width: 100%;
      font-size: pxTorem(14px);
      line-height: pxTorem(20px);
      &:before, &:after {
        content: '';
        position: absolute;
        display: block;
        top: 50%;
        width: calc(50% - 30px);
        transform: translateY(-50%);
        border-bottom: 1px solid #D2D2D2;
      }
      &:before {
        left: 0
      }
      &:after {
        right: 0;
      }
    }
    .social-btn {
      position: fixed;
      display: flex;
      bottom: 0;
      left: 0;
      width: 100%;
      height: $googleLoginBtnGroupHeight;
      padding: 0 15px $googleLoginBtnBottom;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      &.cannot {
        padding-bottom: 10px;
      }
      > span {
        margin: 0 auto;
        font-size: pxTorem(13px);
        line-height: pxTorem(16px);
      }
    }
    .social-login {
      height: $googleLoginBtnHeight;
      line-height: $googleLoginBtnHeight;
      width: 85%;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
      img {
        width: 27px;
        margin-right: 23px;
      }
    }
  }
}

// 針對 iphone5 調整 social-btn group height
@media screen and (device-aspect-ratio: 40/71) {
  $googleLoginBtnHeight: 44px;
  $googleLoginBtnBottom: 20px;
  $googleLoginBtnGroupHeight:  $googleLoginBtnHeight * 2 + 20px + 10px + $googleLoginBtnBottom;
  .login-register-area {
    padding: 30px 15px $googleLoginBtnGroupHeight;
    footer {
      .social-btn {
        height: $googleLoginBtnGroupHeight;
        padding: 0 15px $googleLoginBtnBottom;
        &.cannot {
          > span {
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: $googleLoginBtnGroupHeight;
            background-color: rgba(#fff, .9);
            border-radius: 5px;
            padding: 10px;
          }
        }
      }
    }
  }
}
/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  header {
    border-bottom: 1px solid #D2D2D2;
    padding-bottom: 15px;
    padding-top: 10px;
  }
  .content {
    padding: 25px 5px;
    padding-left: calc(20px + var(--safe-area-inset-left));
    padding-right: calc(20px + var(--safe-area-inset-right));
  }
  .login-register-area__title {
    display: block;
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
  }
  .item {
    .label {
      margin-bottom: 15px;
      font-weight: bold;
    }
  }
  .item.verifiction {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    span.label {
      flex: none;
    }
    .input {
      display: inline-flex;
      flex: 5;
      margin-right: 10px;
    }
    .btn {
      flex: 4;
      min-height: 56px;
      border-radius: 8px;
    }
  }
  .login-register-area {
    footer {
      p {
        margin-top: 26px;
        margin-bottom: 20px;
      }
      .social-login {
        padding: 10px 30px;
        img {
          width: 32px;
          margin-right: 25px;
        }
      }
    }
  }
}
</style>
